import { SVGFC } from '@repo/toolkit/types'

const LinkIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.549 10.4516C12.3773 9.27986 10.3962 9.32425 9.1268 10.5945C7.99381 11.7275 7.12066 12.5998 5.98848 13.7329C4.7183 15.0023 4.67392 16.9834 5.84564 18.1552C7.01737 19.3269 8.99849 19.2826 10.2679 18.0124C10.7504 17.5298 11.8374 16.4436 11.8374 16.4436C12.0731 16.2071 12.0731 15.8238 11.8374 15.5873C11.601 15.3509 11.2177 15.3509 10.9812 15.5873L9.41166 17.1569C8.63293 17.9357 7.42085 18.018 6.70184 17.299C5.98283 16.5799 6.06514 15.3678 6.84387 14.5891L9.98219 11.4507C10.7617 10.6711 11.9738 10.5888 12.6928 11.3078C12.9293 11.5435 13.3126 11.5435 13.549 11.3078C13.7855 11.0714 13.7855 10.6881 13.549 10.4516Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4107 13.5892C10.978 14.1565 11.7479 14.476 12.55 14.476C13.353 14.476 14.1228 14.1565 14.6901 13.5892C15.8893 12.39 16.9149 11.3651 18.1141 10.1659C18.6814 9.59777 19.0002 8.82789 19.0002 8.02574C19.0002 7.22278 18.6814 6.45291 18.1141 5.88559C17.5468 5.31827 16.7769 4.99951 15.974 4.99951C15.1719 4.99951 14.402 5.31827 13.8339 5.88559C13.3166 6.40368 12.7243 6.99602 12.1223 7.59803C11.8859 7.83448 11.8859 8.21781 12.1223 8.45426C12.358 8.6899 12.7421 8.6899 12.9777 8.45426L14.6901 6.74181C15.0307 6.40126 15.4922 6.21 15.974 6.21C16.4558 6.21 16.9174 6.40126 17.2579 6.74181C17.5984 7.08236 17.7897 7.54397 17.7897 8.02574C17.7897 8.50752 17.5984 8.96912 17.2579 9.30967L13.8339 12.7337C13.4942 13.0735 13.0318 13.2656 12.55 13.2656C12.0691 13.2656 11.6067 13.0735 11.2661 12.7337C11.0305 12.4973 10.6472 12.4973 10.4107 12.7337C10.1743 12.9694 10.1743 13.3527 10.4107 13.5892Z"
        fill={color}
      />
    </svg>
  )
}

export default LinkIcon
